import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useContext,
} from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import content from 'Content/content.json';
import { buttonON, buttonOFF } from 'Images';
import stickerImageHandler from './stickerImageHandler';
import Context from '../../context';
import { Image } from 'Components/commonComponents';
import { useSetPosition } from './customHook.js';
import {
  DISPLAY_NONE,
  DISPLAY_BLOCK,
  FRESH_LENS_TAB,
  CLASSIC_LENS_TAB,
  MAKEUP_TAB,
  language,
} from 'Root/constants';
import VMContext from '../context';
import './Sticker.scss';

const {
  data: {
    productInfo: {
      [language]: { classicLens: lensData },
    },
  },
} = content;

export default function Sticker({ vmRef }) {
  const stickerRef = useRef(null);
  const { productId, lensCleared, makeupCleared } = useContext(Context);
  const [buttonImage, setButtonImage] = useState('');
  const [isSticker, setIsSticker] = useState(false);
  const { selectedTab, selectedLensType } = useContext(VMContext);
  const isPositionChanged = useSetPosition(vmRef, stickerRef);

  // @TODO we can use guid instead of "id"/productId
  // Remove dependency from content.json once completed
  const { sticker, show_sticker } = lensData.find(
    (item) => item.id === productId
  );

  useEffect(() => {
    if (lensCleared || makeupCleared) {
      setIsSticker(false);
      stickerRef.current.style.display = lensCleared
        ? DISPLAY_NONE
        : DISPLAY_BLOCK;
    } else if (
      (selectedTab === 'allLens' || selectedTab === MAKEUP_TAB) &&
      selectedLensType === CLASSIC_LENS_TAB &&
      show_sticker === 'no'
    ) {
      setIsSticker(false);
      stickerRef.current.style.display = DISPLAY_NONE;
    } else if (
      selectedTab === 'allLens' &&
      selectedLensType === CLASSIC_LENS_TAB
    ) {
      stickerRef.current.style.display = DISPLAY_BLOCK;
    } else if (
      selectedTab === 'allLens' &&
      selectedLensType === FRESH_LENS_TAB
    ) {
      setIsSticker(false);
      stickerRef.current.style.display = DISPLAY_NONE;
    } else if (
      selectedTab === CLASSIC_LENS_TAB &&
      selectedLensType === CLASSIC_LENS_TAB
    ) {
      stickerRef.current.style.display = DISPLAY_BLOCK;
    } else if (
      selectedTab === FRESH_LENS_TAB ||
      (selectedTab === MAKEUP_TAB && selectedLensType === FRESH_LENS_TAB)
    ) {
      setIsSticker(false);
      stickerRef.current.style.display = DISPLAY_NONE;
    }
  }, [lensCleared, makeupCleared, selectedTab, selectedLensType, productId]);

  useEffect(() => {
    setButtonImage(isSticker ? buttonON : buttonOFF);
    stickerImageHandler(isSticker, sticker, vmRef);
    return () => stickerImageHandler(isSticker, sticker, vmRef);
  }, [isSticker, isPositionChanged, vmRef, productId, lensData, selectedTab]);

  return (
    <div className="sticker-container" id="stickerButton">
      <button
        className="sticker-button"
        ref={stickerRef}
        onClick={() => setIsSticker(!isSticker)}
      >
        {isPositionChanged && !lensCleared && (
          <Fragment>
            <Image src={buttonImage} alt="sticker button" />
            <div className="sticker-btn-text">
              <FormattedMessage
                id="sticker.filterText"
                defaultMessage="Sticker"
              />
              <FormattedMessage id="sticker.ON/OFF" defaultMessage="ON/OFF" />
            </div>
          </Fragment>
        )}
      </button>
    </div>
  );
}

Sticker.propTypes = {
  vmRef: PropTypes.object.isRequired,
};
